import { slice } from './slice';

const { reducer, actions } = slice;

export const { reset: passwordUpdateReset } = actions;

export * from './thunks';
export * as passwordUpdateSelectors from './selectors';

export default reducer;
